<template>
  <div>
    <div class="mx-auto" style="max-width:675px">
      <div class="mb-1" style="font-size:1.4rem">
        {{ $t('page.manageFiling.origCourt.editOrigCourtCase.title') }}
      </div>
      <validation-error-panel/>
      <workflow-wrapper>
        <edit-guide v-if="stepID === 'guide'"
                    key="guide"
                    :origCourtCase="origCourtCaseToEditBean(origCourtCase)"
                    @back="back"
                    @editCase="editCase"
                    @editDetails="editDetails"
                    @editJudgments="editJudgments"/>
        <step-case v-else-if="stepID === 'case'"
                   key="case"
                   :originalBean="origCourtCaseToEditCaseBean(origCourtCase)"
                   :editing="true"
                   @save="saveCase"
                   @cancel="cancel"/>
        <step-details v-else-if="stepID === 'details'"
                      key="details"
                      :originalBean="origCourtCaseToEditDetailsBean(origCourtCase)"
                      :editing="true"
                      @save="saveDetails"
                      @cancel="cancel"/>
        <step-judgments v-else-if="stepID === 'judgments'"
                        key="judgments"
                        :originalBean="origCourtCaseToEditJudgmentsBean(origCourtCase)"
                        :generate-judgment-bean="generateJudgmentBean"
                        :editing="true"
                        @save="saveJudgments"
                        @cancel="cancel"/>
      </workflow-wrapper>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash';
import Filing from '@/application/filing';
import ValidationErrorPanel from '@components/support/ValidationErrorPanel';
import WorkflowWrapper from '@components/support/WorkflowWrapper';
import EditGuide from '@components/support/manageFiling/originatingCourt/EditGuide';
import StepCase from '@components/support/manageFiling/originatingCourt/StepCase';
import StepDetails from '@components/support/manageFiling/originatingCourt/StepDetails';
import StepJudgments from '@components/support/manageFiling/originatingCourt/StepJudgments';

export default {
  components: { WorkflowWrapper, ValidationErrorPanel, EditGuide, StepCase, StepDetails, StepJudgments },
  props: {
    origCourtCaseID: {
      type: String
    },
    generateJudgmentBean: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      origCourtCase: null,
      stepID: 'guide'
    };
  },
  created () {
    this.loadOrigCourtCase();
  },
  methods: {
    origCourtCaseToEditBean: Filing.origCourtCaseToEditBean,
    origCourtCaseToEditCaseBean: Filing.origCourtCaseToEditCaseBean,
    origCourtCaseToEditDetailsBean: Filing.origCourtCaseToEditDetailsBean,
    origCourtCaseToEditJudgmentsBean: Filing.origCourtCaseToEditJudgmentsBean,
    loadOrigCourtCase () {
      return Filing.loadOrigCourtCaseForEditing(this.origCourtCaseID)
        .then((data) => {
          this.origCourtCase = data;
        });
    },
    afterSave () {
      return this.loadOrigCourtCase()
        .then(() => {
          this.$cove.notify({ message: this.$t('application.save.success'), color: 'success' });
          this.stepID = 'guide';
        });
    },
    back () {
      this.$emit('exit');
    },
    cancel () {
      this.stepID = 'guide';
    },
    editCase () {
      this.stepID = 'case';
    },
    editDetails () {
      this.stepID = 'details';
    },
    editJudgments () {
      this.stepID = 'judgments';
    },
    saveCase (bean) {
      this.$cove.blockNow();
      Filing.patchOrigCourtCaseCase({
        origCourtCaseID: this.origCourtCaseID,
        bean
      })
        .then(this.afterSave)
        .finally(() => {
          this.$cove.unblock();
        });
    },
    saveDetails (bean) {
      this.$cove.blockNow();
      Filing.patchOrigCourtCaseDetails({
        origCourtCaseID: this.origCourtCaseID,
        bean
      })
        .then(this.afterSave)
        .finally(() => {
          this.$cove.unblock();
        });
    },
    saveJudgments (bean) {
      this.$cove.blockNow();
      Filing.patchOrigCourtCaseJudgments({
        origCourtCaseID: this.origCourtCaseID,
        bean
      })
        .then(this.afterSave)
        .finally(() => {
          this.$cove.unblock();
        });
    }
  }
};
</script>